import { render } from "./EponClodeOnuStatus.vue?vue&type=template&id=31879df1&scoped=true"
import script from "./EponClodeOnuStatus.vue?vue&type=script&lang=js"
export * from "./EponClodeOnuStatus.vue?vue&type=script&lang=js"

import "./EponClodeOnuStatus.vue?vue&type=style&index=0&id=31879df1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31879df1"]])

export default __exports__